import { Route } from "@/config/rules";
import { parseDate } from "@/helpers/dateHelper";
import { addHours } from "date-fns";
import { BookableDatesResponse, CalendarConfigResponse, CalendarNoteResponse } from "../api/CalendarConfigResponse";

export class CalendarConfig {
    route: string;
    maxBookableDate: Date;
    availableDates: AvailableDates[];
    calendarNotes: CalendarNote[];

    constructor(resp: CalendarConfigResponse) {
    		
        this.maxBookableDate = new Date(resp.maxBookingDate);
        this.availableDates = resp.bookableDates.map(d => new AvailableDates(d));
        this.calendarNotes = resp.calendarNotes.map(n => new CalendarNote(n));
        this.route = resp.bookableDates.length > 0 ? resp.bookableDates[0].route.code : '';
    }
}

export class AvailableDates {
    route: Route;
    dates: AvailableDate[];

    constructor(resp: BookableDatesResponse) {
        this.route = resp.route;
        this.dates = resp.dates.map(d => new AvailableDate(d));
    }

}

export class AvailableDate {
    start: Date;
    end: Date;

    constructor(date: string) {
        this.start = addHours(parseDate(date, "yyyy-MM-dd"), 6); // Adding a few hours here so 2022-01-01 00:00 is not interpreted as 2021-12-31
        this.end = this.start;
    }
}

export class CalendarNote {
    text: string;
    month: number;
    year: number;
    routes: string[];

    constructor(resp: CalendarNoteResponse) {
        this.text = resp.text;
        this.month = resp.month;
        this.year = resp.year;
        this.routes = resp.routes;
    }
}